import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", { class: "title" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-bookmark mr-1 text-warning" }),
  /*#__PURE__*/_createTextVNode(" Accept Invitation Share Project ")
], -1)
const _hoisted_3 = { class: "text-lg-right" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "fa fa-chevron-left mr-2" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Go Back")
const _hoisted_6 = {
  key: 0,
  class: "table-loader chat-load"
}
const _hoisted_7 = {
  key: 1,
  class: "card"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "col-md-4" }, null, -1)
const _hoisted_10 = { class: "col-md-8 text-md-right" }
const _hoisted_11 = {
  key: 0,
  class: "with-spinner-btn"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "Loading...", -1)
const _hoisted_14 = {
  key: 1,
  class: "ml-2"
}
const _hoisted_15 = {
  key: 0,
  class: "with-spinner-btn"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "Loading...", -1)
const _hoisted_18 = {
  key: 1,
  class: "ml-2"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "mb-0 mt-3" }, [
  /*#__PURE__*/_createVNode("strong", null, "Invitation For :")
], -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createVNode("p", { class: "mb-0 mt-3" }, [
  /*#__PURE__*/_createVNode("strong", null, "Details :")
], -1)
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = /*#__PURE__*/_createVNode("strong", null, "Invited Phases :", -1)
const _hoisted_25 = {
  key: 3,
  class: "table-responsive mb-3 font-12"
}
const _hoisted_26 = { class: "table table-bordered table-shadowed mb-0" }
const _hoisted_27 = { class: "table-primary nowrap-text" }
const _hoisted_28 = {
  key: 0,
  scope: "col"
}
const _hoisted_29 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "Phase", -1)
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { colspan: "2" }
const _hoisted_32 = { class: "table table-bordered table-shadowed mb-0" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { colspan: "2" }
const _hoisted_37 = { class: "table table-bordered table-shadowed mb-0" }
const _hoisted_38 = {
  key: 0,
  style: {"width":"50px"}
}
const _hoisted_39 = { class: "col-md-8 text-md-right" }
const _hoisted_40 = {
  key: 0,
  class: "with-spinner-btn"
}
const _hoisted_41 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, null, -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "Loading...", -1)
const _hoisted_43 = {
  key: 1,
  class: "ml-2"
}
const _hoisted_44 = {
  key: 0,
  class: "with-spinner-btn"
}
const _hoisted_45 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, null, -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "Loading...", -1)
const _hoisted_47 = {
  key: 1,
  class: "ml-2"
}
const _hoisted_48 = { class: "modal-wrap default-modal" }
const _hoisted_49 = {
  class: "modal fade",
  id: "deleteAcknowledgementInvitationModal",
  tabindex: "-1",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true"
}
const _hoisted_50 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_51 = { class: "modal-content" }
const _hoisted_52 = { class: "modal-header" }
const _hoisted_53 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "deleteModalLabel"
}, " Invitation Decline ", -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_55 = { class: "modal-body" }
const _hoisted_56 = /*#__PURE__*/_createVNode("div", {
  class: "alert alert-danger mb-0",
  role: "alert"
}, " Are you sure ? You want to decline the Invitation Request. ", -1)
const _hoisted_57 = { class: "form-group" }
const _hoisted_58 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Reason to Decline", -1)
const _hoisted_59 = { class: "modal-footer" }
const _hoisted_60 = {
  key: 0,
  class: "with-spinner-btn"
}
const _hoisted_61 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, null, -1)
const _hoisted_62 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "Loading...", -1)
const _hoisted_63 = {
  key: 1,
  class: "ml-2"
}
const _hoisted_64 = { class: "modal-wrap default-modal" }
const _hoisted_65 = {
  class: "modal fade",
  id: "deleteSelectedInvitation",
  tabindex: "-1",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true"
}
const _hoisted_66 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_67 = { class: "modal-content" }
const _hoisted_68 = { class: "modal-header" }
const _hoisted_69 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "deleteModalLabel"
}, " Decline Selected Task ", -1)
const _hoisted_70 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_71 = { class: "modal-body" }
const _hoisted_72 = /*#__PURE__*/_createVNode("div", {
  class: "alert alert-danger mb-0",
  role: "alert"
}, " Are you sure ? You want to decline the selected Task Invitation. ", -1)
const _hoisted_73 = { class: "form-group" }
const _hoisted_74 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Reason to Decline", -1)
const _hoisted_75 = { class: "modal-footer" }
const _hoisted_76 = {
  key: 0,
  class: "with-spinner-btn"
}
const _hoisted_77 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, null, -1)
const _hoisted_78 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "Loading...", -1)
const _hoisted_79 = {
  key: 1,
  class: "ml-2"
}
const _hoisted_80 = { class: "modal-wrap default-modal" }
const _hoisted_81 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "generateConfirmationModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_82 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_83 = { class: "modal-content" }
const _hoisted_84 = { class: "modal-header" }
const _hoisted_85 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, "Phase Invitation Cofirmation")
], -1)
const _hoisted_86 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_87 = { class: "modal-body" }
const _hoisted_88 = /*#__PURE__*/_createVNode("p", null, "Do you want to Accept Phase Invitation ?", -1)
const _hoisted_89 = {
  key: 0,
  class: "with-spinner-btn"
}
const _hoisted_90 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, null, -1)
const _hoisted_91 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "Loading...", -1)
const _hoisted_92 = {
  key: 1,
  class: "ml-2"
}
const _hoisted_93 = { class: "modal-wrap default-modal" }
const _hoisted_94 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "successfulModal",
  tabindex: "-1",
  "aria-labelledby": "inviteMember",
  "aria-hidden": "true"
}
const _hoisted_95 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_96 = { class: "modal-content text-center" }
const _hoisted_97 = { class: "msg-header" }
const _hoisted_98 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_99 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    class: "bi bi-check-circle",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"
    })
  ])
], -1)
const _hoisted_100 = { class: "msg-body" }
const _hoisted_101 = /*#__PURE__*/_createVNode("h3", null, "Successful!", -1)
const _hoisted_102 = {
  class: "alert alert-success text-center",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _createVNode("a", {
            href: "javascript:void(0)",
            class: "btn default-btn outline d-inline-block",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToInvitation && _ctx.redirectToInvitation(...args)))
          }, [
            _hoisted_4,
            _hoisted_5
          ])
        ])
      ]),
      (_ctx.state.ui.isLoading.projectShareInvitionDetails)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode("img", {
              src: 
                _ctx.state.data.imageBaseUrl
                  ? `${_ctx.state.data.imageBaseUrl}img/loader-spinner.gif`
                  : 'img/loader-spinner.gif'
              ,
              alt: ""
            }, null, 8, ["src"])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.state.ui.isLoading.projectShareInvitionDetails)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode(_component_ErrorList, {
              errors: _ctx.state.ui.errors.errorList.projectShareInvitionDetails,
              hasError: _ctx.state.ui.errors.hasError
            }, null, 8, ["errors", "hasError"]),
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode("div", _hoisted_10, [
                (
  _ctx.state.data.projectShareInvitionDetails.individual === 0
)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      class: "btn default-btn outline secondary d-inline-block mb-0 mr-2",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.join && _ctx.join(...args))),
                      disabled: 
  _ctx.state.ui.isPostLoading.acceptInvitation
    ? _ctx.state.ui.isPostLoading.acceptInvitation
    : false

                    }, [
                      (_ctx.state.ui.isPostLoading.acceptInvitation === true)
                        ? (_openBlock(), _createBlock("span", _hoisted_11, [
                            _hoisted_12,
                            _hoisted_13
                          ]))
                        : (_openBlock(), _createBlock("span", _hoisted_14, "Accept"))
                    ], 8, ["disabled"]))
                  : _createCommentVNode("", true),
                (
  _ctx.state.data.projectShareInvitionDetails.individual === 0
)
                  ? (_openBlock(), _createBlock("button", {
                      key: 1,
                      class: "btn default-btn outline danger d-inline-block mb-0",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showDeclineModal && _ctx.showDeclineModal(...args))),
                      disabled: 
  _ctx.state.ui.isPostLoading.declineProject
    ? _ctx.state.ui.isPostLoading.declineProject
    : false

                    }, [
                      (_ctx.state.ui.isPostLoading.declineProject === true)
                        ? (_openBlock(), _createBlock("span", _hoisted_15, [
                            _hoisted_16,
                            _hoisted_17
                          ]))
                        : (_openBlock(), _createBlock("span", _hoisted_18, "Decline"))
                    ], 8, ["disabled"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _hoisted_19,
            (
  _ctx.state.data.projectShareInvitionDetails &&
  _ctx.state.data.projectShareInvitionDetails.email
)
              ? (_openBlock(), _createBlock("p", _hoisted_20, _toDisplayString(_ctx.state.data.projectShareInvitionDetails.email), 1))
              : _createCommentVNode("", true),
            _hoisted_21,
            (
  _ctx.state.data.projectShareInvitionDetails &&
  _ctx.state.data.projectShareInvitionDetails.description
)
              ? (_openBlock(), _createBlock("p", _hoisted_22, _toDisplayString(_ctx.state.data.projectShareInvitionDetails.description), 1))
              : _createCommentVNode("", true),
            (
  _ctx.state.data.projectShareInvitionDetails.child_invitations &&
  _ctx.state.data.projectShareInvitionDetails.child_invitations.length
)
              ? (_openBlock(), _createBlock("p", _hoisted_23, [
                  _hoisted_24
                ]))
              : _createCommentVNode("", true),
            (
  _ctx.state.data.projectShareInvitionDetails.child_invitations &&
  _ctx.state.data.projectShareInvitionDetails.child_invitations.length
)
              ? (_openBlock(), _createBlock("div", _hoisted_25, [
                  _createVNode("table", _hoisted_26, [
                    _createVNode("thead", _hoisted_27, [
                      _createVNode("tr", null, [
                        (_ctx.state.data.projectShareInvitionDetails.individual === 1)
                          ? (_openBlock(), _createBlock("th", _hoisted_28, [
                              _withDirectives(_createVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.selectAll = $event))
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.state.data.selectAll]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_29
                      ])
                    ]),
                    _createVNode("tbody", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
  .projectShareInvitionDetails.child_invitations, (childPhase, childPhaseIndex) => {
                        return (_openBlock(), _createBlock("tr", { key: childPhaseIndex }, [
                          (_ctx.state.data.projectShareInvitionDetails.individual === 1)
                            ? (_openBlock(), _createBlock("td", _hoisted_30, [
                                _withDirectives(_createVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": ($event: any) => (childPhase.isChecked = $event),
                                  onChange: ($event: any) => (_ctx.check(childPhaseIndex, childPhase.isChecked))
                                }, null, 40, ["onUpdate:modelValue", "onChange"]), [
                                  [_vModelCheckbox, childPhase.isChecked]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode("td", _hoisted_31, [
                            _createVNode("table", _hoisted_32, [
                              _createVNode("tbody", null, [
                                _createVNode("tr", null, [
                                  _createVNode("td", null, [
                                    (

  childPhase.name
)
                                      ? (_openBlock(), _createBlock("p", _hoisted_33, _toDisplayString(childPhase.name), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (childPhase.description)
                                    ? (_openBlock(), _createBlock("td", _hoisted_34, [
                                        _createVNode("p", null, _toDisplayString(childPhase.description), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                (childPhase.tasks.length)
                                  ? (_openBlock(), _createBlock("tr", _hoisted_35, [
                                      _createVNode("td", _hoisted_36, [
                                        _createVNode("table", _hoisted_37, [
                                          _createVNode("tbody", null, [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(childPhase.tasks, (task, taskIndex) => {
                                              return (_openBlock(), _createBlock("tr", { key: taskIndex }, [
                                                (_ctx.state.data.projectShareInvitionDetails.individual === 1)
                                                  ? (_openBlock(), _createBlock("td", _hoisted_38, [
                                                      _withDirectives(_createVNode("input", {
                                                        type: "checkbox",
                                                        "onUpdate:modelValue": ($event: any) => (task.isChecked = $event),
                                                        onChange: ($event: any) => (_ctx.checkTask(childPhaseIndex,taskIndex ,task.isChecked))
                                                      }, null, 40, ["onUpdate:modelValue", "onChange"]), [
                                                        [_vModelCheckbox, task.isChecked]
                                                      ])
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                _createVNode("td", null, _toDisplayString(task.name), 1)
                                              ]))
                                            }), 128))
                                          ])
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_39, [
              (_ctx.isInvitatationSelected || _ctx.state.data.childCheck)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    class: "btn default-btn outline secondary d-inline-block mb-0 mr-2",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showGenerateConfirmationModal && _ctx.showGenerateConfirmationModal(...args)))
                  }, [
                    (_ctx.state.ui.isPostLoading.acceptSelectedPhase === true)
                      ? (_openBlock(), _createBlock("span", _hoisted_40, [
                          _hoisted_41,
                          _hoisted_42
                        ]))
                      : (_openBlock(), _createBlock("span", _hoisted_43, _toDisplayString(_ctx.state.data.selectAll ? "Accept All" : "Accept"), 1))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isInvitatationSelected || _ctx.state.data.childCheck)
                ? (_openBlock(), _createBlock("button", {
                    key: 1,
                    class: "btn default-btn outline danger d-inline-block mb-0",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showSelectedDeclineModal && _ctx.showSelectedDeclineModal(...args)))
                  }, [
                    (_ctx.state.ui.isPostLoading.declineProject === true)
                      ? (_openBlock(), _createBlock("span", _hoisted_44, [
                          _hoisted_45,
                          _hoisted_46
                        ]))
                      : (_openBlock(), _createBlock("span", _hoisted_47, _toDisplayString(_ctx.state.data.selectAll ? "Decline All" : "Decline"), 1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_48, [
      _createVNode("div", _hoisted_49, [
        _createVNode("div", _hoisted_50, [
          _createVNode("div", _hoisted_51, [
            _createVNode("div", _hoisted_52, [
              _hoisted_53,
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeAcknowledgementInvitationModal && _ctx.closeAcknowledgementInvitationModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_54
              ])
            ]),
            _createVNode("div", _hoisted_55, [
              _hoisted_56,
              _createVNode("div", _hoisted_57, [
                _hoisted_58,
                _withDirectives(_createVNode("input", {
                  type: "email",
                  class: "form-control",
                  id: "description",
                  "aria-describedby": "emailHelp",
                  placeholder: "Provide the Reason for Decline",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.data.declineMessage = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.declineMessage]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_59, [
              _createVNode("button", {
                class: "btn default-btn outline danger d-inline-block mb-0",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.decline && _ctx.decline(...args))),
                disabled: 
  _ctx.state.ui.isPostLoading.declineProject
    ? _ctx.state.ui.isPostLoading.declineProject
    : false

              }, [
                (_ctx.state.ui.isPostLoading.declineProject === true)
                  ? (_openBlock(), _createBlock("span", _hoisted_60, [
                      _hoisted_61,
                      _hoisted_62
                    ]))
                  : (_openBlock(), _createBlock("span", _hoisted_63, "Decline"))
              ], 8, ["disabled"]),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeAcknowledgementInvitationModal && _ctx.closeAcknowledgementInvitationModal(...args)))
              }, " No ")
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_64, [
      _createVNode("div", _hoisted_65, [
        _createVNode("div", _hoisted_66, [
          _createVNode("div", _hoisted_67, [
            _createVNode("div", _hoisted_68, [
              _hoisted_69,
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.hideSelectedDeclineModal && _ctx.hideSelectedDeclineModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_70
              ])
            ]),
            _createVNode("div", _hoisted_71, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.errors.errorList.declineTaskInvitations,
                hasError: _ctx.state.ui.errors.hasError
              }, null, 8, ["errors", "hasError"]),
              _hoisted_72,
              _createVNode("div", _hoisted_73, [
                _hoisted_74,
                _withDirectives(_createVNode("input", {
                  type: "email",
                  class: "form-control",
                  id: "description",
                  "aria-describedby": "emailHelp",
                  placeholder: "Provide the Reason for Decline",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.state.data.declineMessage = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.declineMessage]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_75, [
              _createVNode("button", {
                class: "btn default-btn outline danger d-inline-block mb-0",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.declineSelectedPhase && _ctx.declineSelectedPhase(...args))),
                disabled: 
  _ctx.state.ui.isPostLoading.declineSelectedPhase
    ? _ctx.state.ui.isPostLoading.declineSelectedPhase
    : false

              }, [
                (_ctx.state.ui.isPostLoading.declineSelectedPhase === true)
                  ? (_openBlock(), _createBlock("span", _hoisted_76, [
                      _hoisted_77,
                      _hoisted_78
                    ]))
                  : (_openBlock(), _createBlock("span", _hoisted_79, "Decline"))
              ], 8, ["disabled"]),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.hideSelectedDeclineModal && _ctx.hideSelectedDeclineModal(...args)))
              }, " No ")
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_80, [
      _createVNode("div", _hoisted_81, [
        _createVNode("div", _hoisted_82, [
          _createVNode("div", _hoisted_83, [
            _createVNode("div", _hoisted_84, [
              _hoisted_85,
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.hideGenerateConfirmationModal && _ctx.hideGenerateConfirmationModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_86
              ])
            ]),
            _createVNode("div", _hoisted_87, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.errors.errorList.projectShareInvitionDetails,
                hasError: _ctx.state.ui.errors.hasError
              }, null, 8, ["errors", "hasError"]),
              _hoisted_88,
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                disabled: 
  _ctx.state.ui.isPostLoading.acceptSelectedPhase
    ? _ctx.state.ui.isPostLoading.acceptSelectedPhase
    : false
,
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.acceptSelectedPhase && _ctx.acceptSelectedPhase(...args)))
              }, [
                (_ctx.state.ui.isPostLoading.acceptSelectedPhase === true)
                  ? (_openBlock(), _createBlock("span", _hoisted_89, [
                      _hoisted_90,
                      _hoisted_91
                    ]))
                  : (_openBlock(), _createBlock("span", _hoisted_92, _toDisplayString(_ctx.state.data.selectAll ? "Accept All" : "accept"), 1))
              ], 8, ["disabled"]),
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.hideGenerateConfirmationModal && _ctx.hideGenerateConfirmationModal(...args)))
              }, " No ")
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_93, [
      _createVNode("div", _hoisted_94, [
        _createVNode("div", _hoisted_95, [
          _createVNode("div", _hoisted_96, [
            _createVNode("div", _hoisted_97, [
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.closeSuccessfulModal && _ctx.closeSuccessfulModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_98
              ]),
              _hoisted_99
            ]),
            _createVNode("div", _hoisted_100, [
              _hoisted_101,
              _createVNode("div", _hoisted_102, _toDisplayString(_ctx.state.data.successFulMessage), 1)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}